// extracted by mini-css-extract-plugin
export default {"inputs_container":"ManufacturerForm_inputs_container__+JYsp"};